import { css } from '@/styled-system/css';

export const modalBodyStyles = css.raw({
  paddingBlock: 'Modal.Body.padding.vert',
  paddingInline: 'Modal.Body.padding.horz',
  overflowY: 'auto',
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 'auto',
});
